import React, { Fragment, useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Newsletter(props) {
  const {
    strings,
    order,
    setOrder
  } = useContext(ConfiguratorContext)

  const newsletterStrings = strings.payment_form?.newsletter ?? {}

  const onChange = function (e) {
    order.newsletter = e.target.checked ? 'yes' : 'no'
    setOrder({ ...order })
  }

  if (typeof newsletterStrings.label !== 'string' || newsletterStrings.label.length <= 0) {
    return null
  }

  return (
    <>
      <h2 className='config-form__subtitle newsletter'>
        {newsletterStrings.label}
        <div className='config-tooltip'/>
      </h2>

      <div className='config-checkbox newsletter'>
        <label htmlFor='newsletter'>
          <input type='checkbox' name='consent' id='newsletter' onChange={onChange}/>
          <div dangerouslySetInnerHTML={{ __html: newsletterStrings.description }}/>
        </label>
      </div>
    </>
  )
}
